// Pure value logic for TimeBox — parsing the canonical/typed strings. Framework-free.

/** Parse a stored value (`"HH:mm"` or any `\d+\D+\d+`) into hours/minutes. */
export function parseHhmm(value: string): { h: number | null; m: number | null } {
  const match = /(\d{1,2})\D+(\d{1,2})/.exec(String(value || ''));
  if (!match) return { h: null, m: null };
  return { h: Math.min(23, Number(match[1])), m: Math.min(59, Number(match[2])) };
}

export type ParsedTime = { h: number; m: number } | 'empty' | null;

/** Parse typed input: `"1430"` / `"14:30"` → time, `""` → empty, invalid → null. */
export function parseTimeText(input: string): ParsedTime {
  const t = (input || '').trim();
  if (t === '') return 'empty';
  let h: number;
  let m: number;
  if (/^\d{3,4}$/.test(t)) {
    const n = t.padStart(4, '0');
    h = Number(n.slice(0, 2));
    m = Number(n.slice(2));
  } else {
    const match = /(\d{1,2})(?:\D+(\d{1,2}))?/.exec(t);
    if (!match) return null;
    h = Number(match[1]);
    m = match[2] != null ? Number(match[2]) : 0;
  }
  if (h > 23 || m > 59) return null;
  return { h, m };
}
